import React from 'react';
import { Box, Spinner, Center, Text, VStack } from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';
import Login from '../pages/Login';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isInitializing } = useAuth();

  // Spinner SÓ durante a checagem inicial da sessão. Durante um login em andamento
  // (isLoading) o formulário deve permanecer montado — senão o remount apaga a
  // mensagem de erro ("login que não dá erro nenhum").
  if (isInitializing) {
    return (
      <Center minH="100vh" bg="gray.50">
        <VStack spacing={4}>
          <Spinner size="xl" color="brand.500" thickness="4px" />
          <Text color="gray.600">Verificando autenticação...</Text>
        </VStack>
      </Center>
    );
  }

  // Se não autenticado, mostrar página de login
  if (!isAuthenticated) {
    return <Login />;
  }

  // Se autenticado, renderizar o conteúdo protegido
  return <>{children}</>;
};

export default ProtectedRoute;